import SimpleScrollbar from 'simple-scrollbar';
import gw from './general/gw';

export default () => {
	const button = document.querySelector('.js-open-cart');
	const cart = document.querySelector('.js-cart');
	const CLASS_VISIBLE = 'popup--visible';

	renderCart();

	if (cart) {
		if (button) {
			button.addEventListener('click', (e) => {
				e.preventDefault();
				// cart.classList.toggle(CLASS_VISIBLE);
				if (!cart.classList.contains(CLASS_VISIBLE)) {
					openCart();
				}
				else {
					closeCart();
				}
			});
		}


		cart.addEventListener('click', (e) => {
			if(!e.target.closest('.popup__body')) {
				// cart.classList.remove(CLASS_VISIBLE);
				closeCart();
			}
		});

		if (window.location.href.includes('#cart')) {
			removeHash();
			openCart();
		}
	}

	function closeCart() {
		if (cart) {
			// cart.classList.remove(CLASS_VISIBLE);
			cart.querySelector('.js-close-popup').click();
		}
	}

	function openCart() {
		if (cart) {
			const openedPopup = document.querySelector('.popup--visible');
			if (openedPopup) {
				// openedPopup.classList.remove('popup--visible');
				openedPopup.querySelector('.js-close-popup').click();
			}
			// cart.classList.add(CLASS_VISIBLE);
			document.querySelector(`.js-open-popup[data-popup="cart"]`).click();
		}
	}


	document.addEventListener('click', (e) => {
		if (e.target.closest('.js-add-to-bag')) {
			const btn = e.target;

			if (btn.classList.contains('btn--disabled')) {
				const sizeSelector = document.querySelector('.size__btn.js-open-popup');
				if (sizeSelector) {
					sizeSelector.click();
				}
			} else {
				let id = +btn.dataset.id;
				let quantity = 1;

				if (id && quantity) {
					const items = [];
					const item = {
						id: id,
						quantity: quantity
					}
					items.push(item);
					addToCart(items);
				}
			}
		}
	});


	document.addEventListener('click', (e) => {
		if (e.target.closest('.js-line-remove')) {
			let item = e.target.closest('.js-cart-item')
			let line = +item.dataset.index;

			removeFromCart(line);
		}

		if (e.target.closest('.js-line-remove')) {
			let item = e.target.closest('.js-cart-item')
			let line = +item.dataset.index;

			removeFromCart(line);
		}

		if (e.target.closest('.js-quantity-minus')) {
			let item = e.target.closest('.js-cart-item')
			let line = +item.dataset.index;
			let count = +item.querySelector('.quantity__input').value;

			changeCart(line, count-1);
		}
		if (e.target.closest('.js-quantity-plus')) {
			let item = e.target.closest('.js-cart-item')
			let line = +item.dataset.index;
			let count = +item.querySelector('.quantity__input').value;

			changeCart(line, count+1);
		}

	});


	async function addToCart(items_arr) {
		let data = {
			items: items_arr
		};

		let _learnq = window._learnq || [];

		let response = await fetch('/cart/add.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json;charset=utf-8'
			},
			body: JSON.stringify(data)
		});


		if (response.status === 200) {
			renderCart();
			loading(false);
			openCart();
			_learnq.push(['track', 'Added to Cart', item]); //Send event to Klaviyo after items are added to cart
			console.log('item added')
		} else if (response.status === 422) {
			console.log('out of stock');
			openCart();
			// TODO: open cart here
		} else {
			console.log('product add error');
			loading(false);
		}
	}

	async function removeFromCart(line) {
		loading(true);

		let data = {
			'line': line,
			'quantity': 0
		};

		let response = await fetch('/cart/change.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json;charset=utf-8'
			},
			body: JSON.stringify(data)
		});
		if (response.status === 200) {
			renderCart();
			loading(false);
			// openCart();
		}
	}

	async function changeCart(line, q) {
		loading(true);
		let data = {
			'line': line,
			'quantity': q
		};

		let response = await fetch('/cart/change.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json;charset=utf-8'
			},
			body: JSON.stringify(data)
		});

		if (response.status === 200) {
			renderCart();
			loading(false);
		} else if (response.status === 422) {
			console.log('out of stock');
			openCart();
			loading(false);
		} else {
			console.log('product add error');
			loading(false);
		}
	}



	function loading(isLoading) {
		const wrappers = document.querySelectorAll('.js-cart .popup__body-inner');
		const LOADING_CLASS = 'is-loading';

		wrappers.forEach(function(wrapper) {
			if (isLoading) {
				wrapper.classList.add(LOADING_CLASS);
			} else {
				wrapper.classList.remove(LOADING_CLASS);
			}
		});
	}


	function renderCart() {
		// console.log('renderCart()');

		const base = window.location.href.split('?')[0];
		const cartUrl = '/cart?view=alt'
		const url = `${base}${cartUrl}`;

		fetch(url).then(function (response) {
			return response.text();
		}).then(function (html) {

			const element = document.createElement('div');
			element.innerHTML = html;
			const newCart = element.querySelector('.js-cart-insert');

			const cartWrapper = document.querySelector('.js-cart-insert');
			cartWrapper.innerHTML = newCart.innerHTML;

			const counter = element.querySelector('.js-counter');

			const conterEls = document.querySelectorAll('.js-counter');

			if (counter && conterEls.length) {
				const counterText = counter.innerText;
				const countInt = counterText.replace(/[^0-9]+/g, '');

				if (countInt == 0) {
					conterEls.forEach(function(el) {
						el.classList.add('is-hidden');
					});
				} else {
					conterEls.forEach(function(el) {
						el.innerText = `[${countInt}]`;
						el.classList.remove('is-hidden');
					});
				}
			}

			gw(); // reinit cart gift wrap
			SimpleScrollbar.initEl(cartWrapper.querySelector('[ss-container]'));

		}).catch(function (err) {
			console.warn('Something went wrong.', err);
		});
	}

	function removeHash() {
		history.pushState("", document.title, window.location.pathname + window.location.search);
	}

};